import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { MAX_SWATCHES_NUMBER } from '@const/index';
import styles from '@components/ProductCardNew/ProductCardDescription/SwatchesArea/SwatchesArea.styles';
import { ISwatch } from '@typescript/index';
type PropsType = {
  swatches: ISwatch[];
  totalColorsCount?: number;
  productUrl?: string;
  onLinkClick?: () => void;
  onAuxClick?: (e: React.MouseEvent) => void;
};
const SwatchesArea = ({
  swatches,
  totalColorsCount,
  productUrl,
  onLinkClick,
  onAuxClick
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const getRemainingCount = () => {
    if (totalColorsCount && totalColorsCount > MAX_SWATCHES_NUMBER) {
      return `+${totalColorsCount - MAX_SWATCHES_NUMBER}`;
    }
    if (swatches.length > MAX_SWATCHES_NUMBER) {
      return `+${swatches.length - MAX_SWATCHES_NUMBER}`;
    }
    return '';
  };
  const renderSwatch = (swatch: ISwatch, index: number) => {
    const colorLabel = swatch.color || t('colorAvailable');
    const swatchElement = <span sx={styles.productCardInfoSwatch(swatch.image, swatch.color)} role="img" aria-label={`${t('colorVariant')}: ${colorLabel}`} />;
    if (productUrl) {
      return <Link key={`swatch-${swatch.image}-${index}`} href={productUrl} onClick={onLinkClick} onAuxClick={onAuxClick} sx={styles.swatchLink} aria-label={`${t('colorVariant')}: ${colorLabel}`} tabIndex={0}>
          {swatchElement}
        </Link>;
    }
    return <span key={`swatch-${swatch.image}-${index}`} sx={styles.swatchWrapper}>
        {swatchElement}
      </span>;
  };
  const remainingCount = getRemainingCount();
  return swatches.length ? <div sx={styles.productCardInfoSwatches} role="group" aria-label={t('availableColors')}>
      {swatches.map((swatch, index) => {
      if (index < MAX_SWATCHES_NUMBER) {
        return renderSwatch(swatch, index);
      }
      return null;
    })}

      {remainingCount && <span sx={styles.remainingCount}>{remainingCount}</span>}
    </div> : <></>;
};
export default SwatchesArea;